import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import produce, { original } from 'immer';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import communicationQueuesResource from 'src/actions/communicationQueues/communicationQueuesResource';

export default function useEntryPointsChangeDetection(formContext) {
  const dispatch = useDispatch();
  const { workingState, updateState } = formContext;

  const saveChanges = () => {
    const newState = cloneDeep(workingState);
    dispatch(communicationQueuesResource.effects.updateEntryPoints(newState));
  };

  const deleteException = useCallback(
    itemId => {
      const newState: any = produce(workingState, draft => {
        const exceptionsGrouped = original(draft.exceptionsGrouped);

        const itemIndexForDelete = findIndex(exceptionsGrouped, ({ id }) => id === itemId);

        const commQueues = exceptionsGrouped[itemIndexForDelete].communicationQueues;
        draft.exceptionsGrouped.splice(itemIndexForDelete, 1);
        draft.defaultsIds = [...draft.defaultsIds, ...commQueues];
      });

      updateState(
        { exceptionsGrouped: newState.exceptionsGrouped, defaultsIds: newState.defaultsIds },
        { replaceArrayValues: true }
      );
    },
    [workingState, updateState]
  );

  return {
    deleteException,
    saveChanges,
  };
}
